import { useNuxtApp } from '#imports'
import type { apm } from '@elastic/apm-rum'

declare module '#app' {
    interface RuntimeNuxtHooks {
        'apm:ready': (agent: typeof apm) => void
    }
}

export const useApm = () => {
    const { vueApp } = useNuxtApp()
    return (vueApp.config.globalProperties.$apm ?? { captureError() {} }) as typeof apm
}

/**
 * Runs the callback with the RUM agent once the APM plugin has installed it. The agent
 * loads on nuxt-ready, so `useApm()` called during setup still returns the no-op fallback;
 * use this when the reported event can happen before or after that point.
 */
export const onApmReady = (callback: (agent: typeof apm) => void): void => {
    const nuxtApp = useNuxtApp()
    const agent = nuxtApp.vueApp.config.globalProperties.$apm as typeof apm | undefined

    if (agent) callback(agent)
    else nuxtApp.hooks.hookOnce('apm:ready', callback)
}
